import { Model } from 'dva'
import { SIPLine } from './types'
import { TelephonyService } from '../../../Service'
import { IsObject } from '../../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'

const SIPLines: Model = {
  namespace: 'sipLines',
  state: {
    list: [],
  },
  effects: {
    *list(
      { id, useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let sipLines = yield select((state: any) =>
          state.sipLines.list.filter((item: SIPLine) => item.provider.id === id)
        )
        if (!(sipLines.length > 0 && useCache)) {
          sipLines = yield call(TelephonyService.telephonySipLinesList, {
            providerPk: id,
          })
          yield put({ type: 'modifyList', payload: sipLines })
        }
        onSuccess(sipLines)
      } catch (err: any) {
        FailureHandler('Error fetching ASR Models', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { providerId, id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let sipLine = yield select((state: any) =>
          state.sipLines.list.find((sipLine: SIPLine) => sipLine.id === id)
        )
        if (!sipLine) {
          sipLine = yield call(TelephonyService.telephonySipLinesRetrieve, {
            id: id,
            providerPk: providerId,
          })
        }
        yield put({ type: 'modifyList', payload: sipLine })
        onSuccess(sipLine)
      } catch (err) {
        FailureHandler('Could not find the ASR Model!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { providerId, data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TelephonyService.telephonySipLinesCreate, {
          requestBody: {
            ...data,
            provider: providerId,
          },
          providerPk: providerId,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a ASR Model!', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, providerId, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TelephonyService.telephonySipLinesPartialUpdate, {
          id: id,
          providerPk: providerId,
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a ASR Model!', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { idParentAlias, id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        yield call(TelephonyService.telephonySipLinesDestroy, {
          id: id,
          providerPk: idParentAlias,
        })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a sipLine', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: SIPLine) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter((l: SIPLine) => !action.payload.map((p: SIPLine) => p.id).includes(l.id))
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: SIPLine) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetSIPLines(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default SIPLines
